<template>
  <div v-if="lengthList > perPage" class="row">
    <div class="col">
      <div class="dataTables_paginate paging_simple_numbers mt-3 position">
        <ul class="pagination pagination-rounded mb-0">
          <!-- pagination -->
          <b-pagination
              @change="onPaginate($event)"
              v-model="currentPage"
              :total-rows="lengthList"
              :per-page="perPage"
          ></b-pagination>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["listLength", "page", "itemsPerPage"],
  data() {
    return {
      currentPage: 1,
    };
  },
  watch: {
    page: function (val) {
      this.currentPage = val;
    },
  },
  computed: {
    perPage(){
      return this.itemsPerPage ? this.itemsPerPage : 1;
    },
    lengthList() {
      return this.listLength ? this.listLength : 0;
    },
  },
  methods: {
    onPaginate(event) {
      this.$emit("changePage", event);
    },
  },
};
</script>
<style lang="scss" scoped>
.position {
  display: flex;
  justify-content: center;
}

::v-deep .pagination-rounded .page-link {
  font-size: 20px !important;
}
</style>